import { useAuthContext, Role } from "@acto/web-common/auth";
import { useFlagWithContext } from "@acto/web-common/feature-flags";

export function useCanAccessAnalysis(): boolean {
  const { user } = useAuthContext();
  const allRolesEnabled = useFlagWithContext("field-sales-analysis-all-roles", false);

  return allRolesEnabled || (user?.hasRole(Role.SALES_EMPLOYEE) ?? false);
}
